import { IStudent } from "../model";
import { StudentStatusTypeEnum } from "../enums";

export const studentInitial: IStudent = {
  name: "",
  lastName:"",
  organizationId:0,
  status:StudentStatusTypeEnum.ACTIVE,
  studentCode:"",
  classroomId:0,
  schoolId:0,
  subUserId:0,
  avatarUrl:""
};

